<div class="wizard-form-host">
  <mat-stepper
    #stepper
    [linear]="false"
    [orientation]="orientation()"
    class="wizard-stepper"
  >
    <ng-template matStepperIcon="edit" let-index="index">{{ index + 1 }}</ng-template>
    <ng-template matStepperIcon="error" let-index="index">{{ index + 1 }}</ng-template>
    <mat-step label="General" [completed]="step0Valid" [hasError]="!step0Valid">
      <app-describe-step
        #describeRef
        [initialResult]="initial?.describe ?? null"
        (resultChange)="describeResult = $event"
      ></app-describe-step>
    </mat-step>

    <mat-step
      label="Client &amp; Timing"
      [completed]="step1Valid"
      [hasError]="!step1Valid"
    >
      <app-client-timing-step
        #clientTimingRef
        [initialResult]="initial?.clientTiming ?? null"
        (resultChange)="clientTimingResult = $event"
      ></app-client-timing-step>
    </mat-step>

    <mat-step label="Resources" [completed]="step2Valid" [hasError]="!step2Valid">
      <app-resources-step
        #resourcesRef
        [mode]="mode"
        [initialResult]="initial?.resources ?? null"
        (resultChange)="resourcesResult = $event"
      ></app-resources-step>
    </mat-step>

    <mat-step
      label="Assignments"
      [completed]="step3Valid"
      [hasError]="!step3Valid"
    >
      <app-assignments-step
        #assignmentsRef
        [mode]="mode"
        [availableMatters]="
          clientTimingResult?.clientMatters ??
          initial?.clientTiming?.clientMatters ??
          []
        "
        [preferred]="
          resourcesResult?.preferred ?? initial?.resources?.preferred ?? []
        "
        [requestedResources]="
          resourcesResult?.requestedResources ??
          initial?.resources?.requestedResources ??
          []
        "
        [initialResult]="initial?.assignments ?? null"
        (resultChange)="assignmentsResult = $event"
      ></app-assignments-step>
    </mat-step>
  </mat-stepper>
</div>
